var convertToMilliSeconds = (date) => {
    return new Date(date).setHours(0, 0, 0, 0);
};

const DataUtilities = {
    ConvertToMilliSeconds: convertToMilliSeconds
};

export default DataUtilities;
